/**
 * Individualization Request.
 *
 * @group DRM
 *
 * @beta
 */
export const INDIVIDUALIZATION_REQUEST = 'individualization-request';
